import React from 'react';

import { CallbackMode } from '../../logic/main/types';

import { GameList } from '../modular-grid';
import styles from './SearchCategory.module.scss';
import { CategoryGameGridWithContentType } from '../../types/category/categoryTypes';
import { formatMessage } from '../../utils';
import { useWindowSize } from 'src/hooks/useWindowSize';
import { MEDIUM_BREAKPOINT } from '../modular-grid/constants';
import config from '../../config';

interface SearchCategoryMessages {
  viewAllResults: string;
  searchTitle: string;
}
interface SearchCategoryPropTypes {
  category?: CategoryGameGridWithContentType;
  onGameTileClick?: (args: object) => void;
  onGameTileInfoClick?: (args: object) => void;
  onSearchResultsClick?: () => void;
  onViewAllClick?: ({ id }: { id: string }) => void;
  callbackMode: CallbackMode;
  staticTexts: SearchCategoryMessages;
  size?: 'small' | 'medium';
  locale: string;
  currency?: string;
  openingInModal?: boolean;
}

const SearchCategory: React.FC<SearchCategoryPropTypes> = ({
  category,
  onGameTileClick,
  onGameTileInfoClick,
  onSearchResultsClick,
  callbackMode,
  staticTexts,
  size,
  locale,
  currency,
  openingInModal,
}) => {
  const windowWidth = useWindowSize().width;
  if (!category) return null;
  size =
    size ||
    (openingInModal && windowWidth > MEDIUM_BREAKPOINT.max ? 'small' : size);
  const { id, games = [] } = category;

  const getOnClickHandler = (fn: ((args: object) => void) | undefined) => (
    args: object
  ) => {
    fn &&
      fn({
        sectionTitle: category.title,
        id,
        ...args,
      });
  };

  const onInfoClick =
    config.features.gameDetails.mode === 'enabled'
      ? getOnClickHandler(onGameTileInfoClick)
      : undefined;

  const onMoreResultsClick = () =>
    onSearchResultsClick && onSearchResultsClick();

  return (
    <div data-testid="search-category" className={styles.wrapper}>
      <div className={styles.header}>
        <h3 className={styles.heading}>{staticTexts.searchTitle}</h3>
        <span className={styles.headerInfo}>{`(${games.length})`}</span>
      </div>
      <GameList
        insideHeader={false}
        gameList={games.slice(0, 10)}
        onClick={getOnClickHandler(onGameTileClick)}
        onInfoClick={onInfoClick}
        callbackMode={callbackMode}
        locale={locale}
        currency={currency}
        size={size}
      />
      {games.length >= 5 && (
        <div className={styles.button}>
          <button
            className={styles.viewAllButton}
            data-testid="search-view-all"
            onClick={onMoreResultsClick}
          >
            {formatMessage(staticTexts.viewAllResults, {
              resultsCount: games.length,
            })}
          </button>
        </div>
      )}
    </div>
  );
};

export default SearchCategory;
